import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ExamProvider } from "./context/ExamContext";

// Importa tus "vistas" o "páginas"
import Home from "./Home";
import CrearExamen from "./components/CrearExamen";
import ExamenList from "./components/ExamenList";
import AdministradorExamenes from "./components/AdministradorExamenes";
import ReportesErrores from "./components/ReportesErrores";
import ResultadosExamenes from "./components/ResultadosExamenes";
import ReportesErroresEstudiante from "./components/ReportesErroresEstudiante";
import Administration from "./components/Administration";
import AdministrarEmpresas from "./components/AdministrarEmpresas";
import Login from "./components/Login";
import Register from "./components/Register";
import Settings from "./components/Settings";
import PasswordReset from "./components/PasswordReset";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/layout/MainLayout";

function App() {
  return (
    <AuthProvider>
      <ExamProvider>
        <div className="App">
          <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/" element={<Home />} />

            {/* Rutas protegidas */}
            <Route
              path="/exams"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <ExamenList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-exam"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <MainLayout>
                    <CrearExamen />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/exam-administrator"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <MainLayout>
                    <AdministradorExamenes />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/error-reports"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <MainLayout>
                    <ReportesErrores />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/exam-results"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <ResultadosExamenes />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-error-reports"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <ReportesErroresEstudiante />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administration"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <MainLayout>
                    <Administration />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/companies"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <MainLayout>
                    <AdministrarEmpresas />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <Settings />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Ruta catch-all */}
            <Route path="*" element={<h2>Página no encontrada (404)</h2>} />
          </Routes>
        </div>
      </ExamProvider>
    </AuthProvider>
  );
}

export default App;
